const API_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:2000'
  : '';

export default API_URL;